import React from "react";
import styled from "styled-components";

export default styled.a`
    border-bottom: 1px solid #CECEDC;
    height: 77px;
    position: relative;
    display: block;
`;